module.exports = __webpack_public_path__ + "static/media/user-edit-solid.6efdeb35.svg";